import React from 'react';

import i18n from 'i18n-js';
import { Typography } from '@material-ui/core';

import styles from './styles';
import { PricingLevelsCard } from './components/PricingLevelsCard';
import { useAppSelector } from 'index';

export default function AdvancedPricing() {
    const classes = styles();
    const restaurant = useAppSelector((state) => state.restaurantDetails.restaurantInformation);

    return (
        <div className={classes.root}>
            <Typography variant="h5" align="left">
                {i18n.t('restaurant.advancedPricing')}
            </Typography>
            <PricingLevelsCard />
            {(restaurant.managedGroupPricingLevels ?? []).map((group) => (
                <PricingLevelsCard key={group.groupId} group={group} />
            ))}
        </div>
    );
}
